import React, { useEffect, useState } from "react";
import { useLocation, useHistory, Link } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { getPropiedades } from "../helpers/rutaPropiedades";
import imagennavbar from "../images/LOGO Q2-2.png";
import logojpg1 from "../images/LOGO Q2-2.png";

import {
  AppBar,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
  CssBaseline,
  makeStyles,
  Box
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";

const useStyles = makeStyles((theme) => ({
  // Aplicamos la fuente Paralucent de forma global a todo el body
  '@global': {
    body: {
      fontFamily: "Paralucent, sans-serif",
    },
  },
  hero: {
    position: "relative",
    width: "100%",
    backgroundImage: `url(${imagennavbar})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
  },
  appBar: {
    backgroundColor: "#000", // Fondo negro
    color: "#fff",           // Texto blanco
    boxShadow: "none",
    position: "static",
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between", 
    minHeight: 140,
    padding: theme.spacing(1, 2),
    // En pantallas pequeñas apilamos verticalmente
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      minHeight: "auto", // Para que se ajuste al contenido
    },
  },
  // Contenedor para el menú hamburguesa + Logo, alineados a la izquierda
  leftBox: {
    display: "flex",
    alignItems: "center",
    // En pantallas pequeñas, los separamos un poco del texto
    [theme.breakpoints.down("sm")]: {
      marginBottom: theme.spacing(1),
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  logo: {
    height: "120px",
    width: "auto",
    marginLeft: theme.spacing(1),
  },
  // Texto principal (centrado en dos líneas)
  centerText: {
    flex: 1,               // Ocupa espacio central
    textAlign: "center",
    fontSize: "2.5rem",
    fontWeight: "bold",
    color: "#fff",
    // Se actualiza a Paralucent
    fontFamily: "Paralucent, sans-serif",
    lineHeight: 1.2,
    [theme.breakpoints.down("md")]: {
      fontSize: "2rem",
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.8rem",
      marginBottom: theme.spacing(1),
    },
  },
  // Segundo texto (derecha en pantallas grandes, centrado en chicas)
  rightText: {
    fontSize: "1.7rem",
    fontWeight: "bold",
    color: "#fff",
    // Se actualiza a Paralucent
    fontFamily: "Paralucent, sans-serif",
    marginRight: theme.spacing(2),
    [theme.breakpoints.down("md")]: {
      fontSize: "1.2rem",
    },
    [theme.breakpoints.down("sm")]: {
      marginRight: 0,
      textAlign: "center",
      marginBottom: theme.spacing(1),
    },
  },
  drawerPaper: {
    width: 200,
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    transition: "transform 0.3s ease-in-out",
    fontSize: "3rem",
    paddingTop: theme.spacing(11),
    color: "black",
  },
  listItem: {
    fontSize: "1.5rem",
    fontWeight: "bold",
  },
}));

const NavBar = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();

  const [user, setUser] = useState("Iniciar sesión");
  const [payload, setPayload] = useState({ role: "" });
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem("usuario")) || "Iniciar Sesión");
    actualizarData();
    checkToken();
    // eslint-disable-next-line
  }, [location]);

  const actualizarData = () => {
    getPropiedades(0, 100).then((datos) => {
      // ...
    });
  };

  const checkToken = () => {
    const token = JSON.parse(localStorage.getItem("token")) || "";
    if (token.length > 0) {
      const token_decode = jwt_decode(localStorage.getItem("token"));
      setPayload(token_decode.usuario);
    }
  };

  const handleLogin = () => {
    localStorage.setItem("token", JSON.stringify(""));
    localStorage.setItem("id", JSON.stringify(""));
    localStorage.setItem("usuario", JSON.stringify("Iniciar Sesión"));
    setUser("Iniciar Sesión");
    setPayload({ role: "" });
    history.push("/login");
  };

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const list = () => (
    <div
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        <ListItem button component={Link} to="/" className={classes.listItem}>
          <ListItemText 
            primary="Home" 
            primaryTypographyProps={{ style: { fontSize: "1.5rem", fontWeight: "bold" } }}
          />
        </ListItem>
        {/* ...más items de menú si los necesitas... */}
      </List>
      <Divider />
      <List>
        <ListItem button onClick={handleLogin} className={classes.listItem}>
          <ListItemText primary={user} />
        </ListItem>
      </List>
    </div>
  );

  return (
    <div className={classes.hero}>
      <CssBaseline />
      <AppBar className={classes.appBar}>
        <Toolbar className={classes.toolbar}>
          {/* IZQUIERDA: Menú hamburguesa + Logo */}
          <Box className={classes.leftBox}>
            <IconButton
              edge="start"
              className={classes.menuButton}
              color="inherit"
              aria-label="menu"
              onClick={toggleDrawer(true)}
            >
              <MenuIcon style={{ fontSize: "3rem" }} />
            </IconButton>
            <img src={logojpg1} alt="Logo" className={classes.logo} />
          </Box>
          {/* CENTRO: Texto principal en dos renglones */}
          <Typography className={classes.centerText}>
            Transformá tus eventos con
            <br />
            tecnología innovadora.
          </Typography>
          {/* DERECHA: Segundo texto */}
          <Typography className={classes.rightText}>
            Acreditaciones rápidas, seguras y a tu alcance.
          </Typography>
        </Toolbar>
      </AppBar>
      {/* Drawer (menú lateral) */}
      <Drawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        {list()}
      </Drawer>
    </div>
  );
};

export default NavBar;
